import  { useState, useEffect } from 'react';
import Modal from 'react-modal';
import logo from '../../assets/success.png';
import { formatAddress } from '../../tools/utils';
import { Link } from 'react-router-dom';
import { BlockUI } from '../../components/Loader/BlockUI';
import { useTranslation } from 'react-i18next';
import { approveOrDenyCertWatch, getCertWatchByContactId, removeCertWatchRequest } from '../../redux/thunks/certConnectThunks';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store';
import { closeModal, openModal } from '../../redux/slices/modalSlice';
import { Loader } from '../../components/Loader';

const OrganizationConnectionsTable = ({ contactId }) => {
  const dispatch = useDispatch<AppDispatch>();
const { certWatchData, loading, error } = useSelector(
  (state: RootState) => state.certConnect 
);
  const { t } = useTranslation();
  const [loadingAction, setLoadingAction] = useState(false);
  const [filteredList, setFilteredList] = useState([]);
  const [modalMessage, setModalMessage] = useState('');  
  const [isModalOpen, setIsModalOpen] = useState(false); 
  const { certRequestModal } = useSelector((state: RootState) => state.modals);
  

useEffect(() => {
  if (contactId) {
    dispatch(getCertWatchByContactId());
  }
}, [contactId, dispatch]);

useEffect(() => {
  if (certWatchData && certWatchData.length > 0) {
    const filtered = certWatchData.filter(
      (item) =>
        item.StatusReason === "Approved" || item.StatusReason === "Pending"
    );
    setFilteredList(filtered);
  } else {
    setFilteredList([]); 
  }
}, [certWatchData]);

const handleApproveDeny = async (id, isApproved) => {
  const action = isApproved ? 'Approved' : 'Denied';
  try {
    setLoadingAction(true);
 const resultAction = await dispatch(
      approveOrDenyCertWatch({ certWatchRequestId: id, isApproved })
    );    
      const successMessage = isApproved
      ? t("MyCCOPro.OrganizationConnections.RequestApproved")
      : t("MyCCOPro.OrganizationConnections.RequestDenied");

    setModalMessage(successMessage);
dispatch(openModal("certRequestModal"))
    setFilteredList((prev) =>
      prev
        .map((item) =>
          item.CertWatchRequestId === id
            ? { ...item, StatusReason: action }
            : item
        )
        .filter((item) => item.StatusReason === 'Approved' || item.StatusReason === 'Pending')
    );
  } catch (error) {
    const message = error?.response?.data?.message || 'An error occurred while processing the request.';
    setModalMessage(message);
    setIsModalOpen(true);
  } finally {
    setLoadingAction(false);
  }
};


const handleRemove = async (id) => {
  try {
    setLoadingAction(true);
await dispatch(removeCertWatchRequest({ Id: id, ContactId: contactId })).unwrap();
setFilteredList((prev) => prev.filter((item) => item.Id !== id));
    setModalMessage(t("MyCCOPro.OrganizationConnections.RequestRemoved"));
    setIsModalOpen(true);
     setFilteredList((prev) => prev.filter((item) => item.Id !== id));
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to remove the request.';
    setModalMessage(message);
 dispatch(openModal("certRequestModal"))
  } finally {
    setLoadingAction(false);
  }
};



const toggleModal = async () => {
  await dispatch(getCertWatchByContactId());
  dispatch(closeModal("certRequestModal"))

};

  return (
    <> 
       <div className="cco_row cco_row_8">
              <div className="cco_col">
                <div className="cco_text cco_text_11">
                  <div className="cco_text_inner">
                    <strong>
                      <a href="/account"> {t('header.accountDetails')}</a>
                    </strong>{' '}
                    &gt; {t("MyCCOPro.OrganizationConnections.Title")}
                  </div>
                </div>
              </div>
            </div>
     <div className="cco_row cco_row_7">
                <div className="cco_col cco_col_6">
                  <div className="cco_text cco_text_10">
                    <div className="cco_text_inner">
                     
                      <p>
  {t('MyCCOPro.OrganizationConnections.certConnectCandidateDescriptionPart1')}
  <a
    href="https://www.nccco.org/PPA"
    target="_blank"
    rel="noopener noreferrer"
  >
    {t('MyCCOPro.OrganizationConnections.certConnectCandidateDescriptionLinkText')}
  </a>
  {t('MyCCOPro.OrganizationConnections.certConnectCandidateDescriptionPart2')}
</p>
                      
                       
                    </div>
                  </div>
                </div>
              </div>
      <div style={{ marginTop: '40px'  , marginBottom: '30px' }}>
      <BlockUI title="" blocking={loadingAction} />


<div className="cco_row cco_row_3">
  <div className="cco_col">
     { loading ? (
       <div className="cco_row cco_row_3">
          <Loader />
      </div>
  ) : filteredList.length === 0 ? (
      <div className="cco_text cco_text_10" style={{
    justifyContent: "center", 
    alignItems: "center",    
    textAlign: "center",
  }}>
        <div className="cco_text_inner">
          <p>{t("MyCCOPro.OrganizationConnections.NoConnections")}</p>
        </div>
      </div>
    ) : (

      
      <ul className="cco_accordion">
        {filteredList.map((item, index) => (
          <li key={item.OrganizationId || index} className="cco_accordion_item">
            <div className="cco_accordion_item_body" style={{ display: 'block' }}>
              <div>
                <table className="cco_table cco_table_1">
                  <tbody className="cco_table_body">
                    <tr className="cco_table_row">
                      <td className="cco_table_cell cco_table_cell_medium">
                        <div className="cco_blurb cco_blurb_0">
                          <div className="cco_blurb_label">{t("MyCCOPro.OrganizationConnections.OrganizationName")}</div>
                          <div className="cco_blurb_value">
                            <strong>{item.OrganizationName || '[Company Name]'}</strong>
                          </div>
                        </div>
                        <div className="cco_blurb cco_blurb_0">
                          <div className="cco_blurb_label">{t("MyCCOPro.OrganizationConnections.Address")}</div>
                          <div className="cco_blurb_value">
                            <strong>
                              {item.OrganizationDetails ? (
                                formatAddress({
                                  Zip: item.OrganizationDetails.ZipCode,
                                  City: item.OrganizationDetails.City,
                                  Type: '',
                                  Street1: item.OrganizationDetails.Address1,
                                  Street2: item.OrganizationDetails.Address2,
                                  State: '',
                                })
                              ) : (
                                 t("MyCCOPro.OrganizationConnections.NoAddress")
                              )}
                            </strong>
                          </div>
                        </div>
                      </td>
                      <td className="cco_table_cell cco_table_cell_small"></td>
                      <td className="cco_table_cell cco_table_cell_small">
                        <div className="cco_blurb cco_blurb_align_right cco_blurb_0">
                          <div className="cco_blurb_label">{t("MyCCOPro.OrganizationConnections.Status")}</div>
                          <div className="cco_blurb_value">
                            <strong>{item.StatusReason}</strong>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

                {item.StatusReason === "Approved" && (
                  <ul className="cco_menu cco_menu_3">
                    <li className="cco_menu_item">
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleRemove(item.Id);
                        }}
                        style={{ cursor: 'pointer', textDecoration: 'none' }}
                      >
                        {t("MyCCOPro.OrganizationConnections.Remove")}
                  
                      </Link>
                    </li>
                  </ul>
                )}
        
                {item.StatusReason === "Pending" && (
              <ul className="cco_menu cco_menu_7">
                                                    <li className="cco_menu_item">
                                                        <button className="cco_form_submit"   onClick={(e) => {
                          e.preventDefault();
                          handleApproveDeny(item.Id, true);
                        }}
                        style={{ cursor: 'pointer', textDecoration: 'none' }}>
                                                       
                                                           {t("MyCCOPro.OrganizationConnections.Approve")}
                                                        </button>
                                                    </li>

                                                 
                                                        <li className="cco_menu_item">
                                                            <a href="" onClick={(e) => {
                          e.preventDefault();
                          handleApproveDeny(item.Id, false);
                        }}
                        style={{ cursor: 'pointer', textDecoration: 'none' }}> {t("MyCCOPro.OrganizationConnections.Deny")}</a>
                                                        </li>
                                                 
                                                </ul>
                )}
                
              </div>
            </div>
          </li>
        ))}
      </ul>
    )}
  
  </div>
</div>
{certRequestModal && (
 <Modal
  isOpen={true}
   onRequestClose={()=>dispatch(openModal("certRequestModal"))}
  shouldCloseOnOverlayClick={false}
  contentLabel="CertWatch Modal"
  style={{
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '12px',
      padding: '30px',
      width: '400px',
      textAlign: 'center',
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
  }}
>
  <img src={logo} alt="success" style={{ width: '60px', marginBottom: '20px' }} />
  <p style={{ fontSize: '16px', color: '#2d3748' }}>{modalMessage}</p>
  <button
   onClick={()=>
          dispatch(closeModal("certRequestModal"))}   
           style={{
      marginTop: '20px',
      padding: '10px 20px',
      backgroundColor: '#c67b05',
      color: '#fff',
      border: 'none',
      borderRadius: '8px',
      cursor: 'pointer',
    }}
  >
     {t("MyCCOPro.OrganizationConnections.Close")}
  </button>
</Modal>
)
}

    </div>
      </>
  );
};

export default OrganizationConnectionsTable;